module.exports = __webpack_public_path__ + "img/07_choice 1.12213472.png";